/**
 * P39 (Feb 28, 2026) — /edi-submit has been retired.
 *
 * The Submit-EDI workflow lives at /claims (the Send-to-ODM button)
 * since it's the same flow with the agency-aware multi-tenant EDI
 * builder. This component redirects any bookmarked links and shows a
 * one-time toast so users know where the feature moved.
 */
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'sonner';

const EDISubmitPage = () => {
  useEffect(() => {
    toast.info('EDI Submit has moved', {
      description: 'Use the Claims page → "Send to ODM" button. This new flow correctly identifies each agency on every claim.',
      duration: 6000,
    });
  }, []);
  return <Navigate to="/claims" replace />;
};

export default EDISubmitPage;
